<template>
	<div class="mine-page">
		<div class="page-bg"></div>

		<van-pull-refresh
			v-model="isLoading"
			@refresh="onRefresh"
			pulling-text="Sao chép nhanh quy trình thả xuống"
			loosing-text="Bản sao nhắc nhở của quá trình phát hành"
			loading-text="Loading"
			success-text="Refresh successful"
			class="page-refresh"
		>
			<div class="header-section">
				<div class="header-glow glow-1"></div>
				<div class="header-glow glow-2"></div>

				<van-nav-bar class="nav-bar">
					<template #left>
						<div class="nav-icon-btn" @click="showSetting">
							<van-icon name="setting-o" color="#fff" />
						</div>
					</template>

					<template #right>
						<div class="nav-icon-btn logout-btn" @click="loginout">
							<img src="img/logout.svg" alt="" />
						</div>
					</template>
				</van-nav-bar>

				<div class="profile-card" @click="doLogin">
					<div class="avatar-wrap">
						<van-image
							round
							class="user-img"
							:src="avatarSrc"
							fit="cover"
							@error="handleAvatarError"
						>
							<template v-slot:loading>
								<van-loading type="spinner" />
							</template>

							<template v-slot:error>
								<img
									class="avatar-fallback"
									src="img/mine/avatar.png"
									alt=""
								/>
							</template>
						</van-image>
						<div class="avatar-ring"></div>
					</div>

					<div class="profile-info">
						<p class="user-name">
							<span class="name-text">{{ userInfo.username }}</span>
							<img class="vip-icon" src="img/vip.png" />
							<span class="vip-text">{{ userInfo.vip }}</span>
						</p>
						<p class="user-subtext">{{ userInfo.ip || $t("setting.more_service") }}</p>
					</div>
				</div>
			</div>

			<div class="content-section">
				<div class="action-card finance-card">
					<div class="finance-item" @click="doRecharge">
						<div class="finance-icon-wrap">
							<img src="/img/recharge.svg" alt="" class="icon" />
						</div>
						<div class="finance-texts">
							<span class="text">{{ $t("my.recharge") }}</span>
						</div>
					</div>

					<div class="finance-divider"></div>

					<div class="finance-item" @click="doWithdrawal">
						<div class="finance-icon-wrap">
							<img src="/img/withdraw.svg" alt="" class="icon" />
						</div>
						<div class="finance-texts">
							<span class="text">{{ $t("my.withdraw") }}</span>
						</div>
					</div>
				</div>

				<div v-if="userInfo.money" class="wallet-card">
					<div class="wallet-head van-hairline--bottom">
						<p class="wallet-title">{{ $t("my.my_balance") }}</p>
						<span class="refresh-balance-btn" @click="refresh">
							{{ $t("auth.t3") }}
						</span>
					</div>

					<div class="wallet-body">
						<div class="wallet-item">
							<div class="wallet-main">
								<div class="wallet-value van-ellipsis">
									{{ userInfo.money }}
								</div>
							</div>
							<div class="wallet-label">{{ $t("auth.t2") }}</div>
						</div>

						<div class="wallet-item wallet-item-score">
							<div class="wallet-main">
								<div class="wallet-value van-ellipsis">
									{{ userInfo.score }}
								</div>
							</div>
							<div class="wallet-label">{{ $t("auth.t1") }}</div>
						</div>
					</div>
				</div>

				<div :style="{ marginTop: menu_top + 'px' }" class="menu-card">
					<div
						class="menu-item"
						@click="$router.push({ path: '/Personalreport' })"
					>
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/baobiao.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("my.my_statement") }}
							</span>
						</div>
					</div>

					<div
						class="menu-item"
						@click="$router.push({ path: '/Moneylog' })"
					>
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/mingxi.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("auth.t10") }}
							</span>
						</div>
					</div>

					<div
						class="menu-item"
						@click="$router.push({ path: '/GameRecord' })"
					>
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/youxi.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("my.task_record") }}
							</span>
						</div>
					</div>

					<div
						class="menu-item"
						@click="$router.push({ path: '/Infomation' })"
					>
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/user.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("my.personal_center") }}
							</span>
						</div>
					</div>

					<div class="menu-item" @click="toNotice">
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/gonggao.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("my.information_announcement") }}
							</span>
						</div>
					</div>

					<div class="menu-item" @click="toService">
						<div class="menu-item-inner">
							<div class="menu-icon-wrap">
								<van-image class="menu-item-icon" src="img/mine/kefu_1.svg">
									<template v-slot:loading>
										<van-loading type="spinner" />
									</template>
								</van-image>
							</div>
							<span class="menu-item-label">
								{{ $t("my.online_service") }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</van-pull-refresh>
	</div>
</template>

<script>
export default {
	data() {
		return {
			userInfo: {},
			menu_top: 0,
			isLoading: false,
			defaultAvatar: "img/mine/avatar.png",
			avatarError: false
		};
	},
	computed: {
		avatarSrc() {
			if (this.avatarError) {
				return this.defaultAvatar;
			}
			const img = this.userInfo.header_img;
			if (!img || img === "null" || img === "undefined") {
				return this.defaultAvatar;
			}
			return img;
		}
	},
	methods: {
		handleAvatarError() {
			this.avatarError = true;
		},
		refresh() {
			this.isLoading = true;
			setTimeout(() => {
				this.isLoading = false;
				if (localStorage.getItem("token")) {
					this.$toast(this.$t("reservation.refresh"));
				} else {
					this.$router.push({ path: "/Login" });
				}
			}, 500);
		},
		exit() {
			this.$toast(this.$t("my.finish_task"));
		},
		showSetting() {
			if (localStorage.getItem("token")) {
				this.$router.push({ path: "/Setting" });
			} else {
				this.$router.push({ path: "/Login" });
			}
		},
		loginout() {
			localStorage.clear();
			this.$router.push({ path: "/Login" });
		},
		toNotice() {
			if (localStorage.getItem("token")) {
				this.$router.push({ path: "/Notice" });
			} else {
				this.$router.push({ path: "/Login" });
			}
		},
		onRefresh() {
			setTimeout(() => {
				this.isLoading = false;
				if (localStorage.getItem("token")) {
					this.getUserInfo();
					this.$toast(this.$t("reservation.refresh"));
				} else {
					this.$router.push({ path: "/Login" });
				}
			}, 500);
		},
		doLogin() {
			if (localStorage.getItem("token")) {
				this.$router.push({ path: "/Infomation" });
			} else {
				this.$router.push({ path: "/Login" });
			}
		},
		doPay() {
			const kefu =
				this.$store.getters.getBaseInfo &&
				this.$store.getters.getBaseInfo.kefu;
			if (kefu) {
				window.location.href = kefu;
			} else {
				this.$toast.fail("客服链接未配置");
			}
		},
		doRecharge() {
			const kefu =
				this.$store.getters.getBaseInfo &&
				this.$store.getters.getBaseInfo.kefu;
			if (kefu) {
				window.location.href = kefu;
			} else {
				this.$toast.fail("客服链接未配置");
			}
		},
		doWithdrawal() {
			this.$http({
				method: "get",
				url: "user_get_bank"
			}).then(res => {
				if (res.data.is_bank) {
					this.$router.push("withdraw");
				} else {
					this.$router.push("Setbank");
					this.$toast.fail(this.$t("setting.set_bank"));
				}
			});
		},
		toService() {
			if (this.$store.getters.getBaseInfo.iskefu == 1) {
				this.$router.push("ServiceOnline");
			} else {
				this.$toast.fail(this.$t("setting.forbid"));
			}
		},
		getUserInfo() {
			this.$http({
				method: "get",
				url: "user_info"
			}).then(res => {
				if (res.code === 200) {
					this.userInfo = res.data;
					this.avatarError = false;
					this.menu_top = 0;
					if (!this.userInfo.header_img) {
						this.userInfo.header_img = this.defaultAvatar;
					}
					if (this.userInfo.status !== 1) {
						this.$toast(this.$t("video.account_out"));
						localStorage.clear();
						this.$router.push({ path: "/Login" });
					}
				} else if (res.code === 401) {
					this.$toast(res.msg);
				}
			});
		}
	},
	created() {
		if (localStorage.getItem("token")) {
			this.getUserInfo();
		} else {
			this.userInfo.username = this.$t("setting.log_reg");
			this.userInfo.ip = this.$t("setting.more_service");
			this.userInfo.header_img = this.defaultAvatar;
		}
	}
};
</script>

<style scoped lang="less">
.mine-page {
	position: relative;
	min-height: 100vh;
	padding-bottom: 98px;
	background:
		radial-gradient(circle at top, rgba(255, 221, 232, 0.9) 0%, rgba(255, 244, 247, 0.96) 28%, #fff 68%);
	overflow-x: hidden;
}

.page-bg {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 360px;
	background: linear-gradient(135deg, #ff95ba 0%, #ff6f9e 38%, #f04d87 70%, #d73b88 100%);
	border-radius: 0 0 34px 34px;
	box-shadow: 0 12px 32px rgba(227, 92, 138, 0.18);
	pointer-events: none;
	z-index: 0;
}

.page-refresh {
	position: relative;
	z-index: 2;
}

.header-section {
	position: relative;
	padding-bottom: 70px;
	overflow: hidden;
	z-index: 2;
}

.header-glow {
	position: absolute;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.12);
	z-index: 0;
	pointer-events: none;
}

.glow-1 {
	width: 180px;
	height: 180px;
	right: -40px;
	top: -20px;
}

.glow-2 {
	width: 120px;
	height: 120px;
	left: -20px;
	top: 120px;
	background: rgba(255, 255, 255, 0.08);
}

.nav-bar {
	position: relative;
	z-index: 5;
	background: transparent !important;
}

::v-deep .van-nav-bar {
	background: transparent !important;
}

::v-deep .van-nav-bar::after {
	border: none !important;
}

::v-deep .van-nav-bar__content {
	height: 88px;
}

.nav-icon-btn {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.14);
	backdrop-filter: blur(8px);
	position: relative;
	z-index: 6;
}

::v-deep .nav-icon-btn .van-icon {
	font-size: 28px !important;
}

.logout-btn img {
	width: 24px;
	height: 24px;
	display: block;
}

.profile-card {
	position: relative;
	z-index: 5;
	margin: 8px 20px 0;
	padding: 24px 22px;
	border-radius: 28px;
	background: rgba(255, 255, 255, 0.16);
	backdrop-filter: blur(14px);
	box-shadow: 0 14px 30px rgba(162, 30, 85, 0.16);
	display: flex;
	align-items: center;
	min-height: 120px;
}

.avatar-wrap {
	position: relative;
	width: 94px;
	height: 94px;
	flex-shrink: 0;
}

.user-img {
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: rgba(255, 255, 255, 0.25);
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.avatar-ring {
	position: absolute;
	inset: 0;
	border-radius: 50%;
	border: 2px solid rgba(255, 255, 255, 0.32);
	pointer-events: none;
}

.avatar-fallback {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
	display: block;
}

::v-deep .van-loading__spinner {
	height: 34px;
	width: 34px;
}

::v-deep .van-image__error-icon {
	font-size: 46px;
}

.profile-info {
	flex: 1;
	min-width: 0;
	margin-left: 18px;
}

.user-name {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin: 0;
	line-height: 1.3;
	color: #fff;
	font-weight: 700;
	word-break: break-word;
}

.name-text {
	max-width: 58%;
	font-size: clamp(24px, 5vw, 36px);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.vip-icon {
	width: 18px;
	height: 18px;
	margin: 0 8px 0 10px;
}

.vip-text {
	font-weight: 700;
	font-size: clamp(18px, 4vw, 26px);
	color: #fff;
}

.user-subtext {
	margin: 8px 0 0;
	font-size: clamp(14px, 3.5vw, 18px);
	line-height: 1.4;
	color: rgba(255, 255, 255, 0.82);
	word-break: break-word;
}

.content-section {
	position: relative;
	margin-top: -34px;
	padding: 0 16px 24px;
	min-height: 500px;
	z-index: 10;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: #ffffff;
	font-size: 18px;
}

::v-deep .van-toast {
	width: auto !important;
	max-width: 90vw;
	min-width: 180px;
	padding: 12px 20px !important;
	white-space: nowrap !important;
}

::v-deep .van-toast__text {
	white-space: nowrap !important;
	word-break: keep-all !important;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.2;
}

.action-card {
	position: relative;
	z-index: 12;
	background: rgba(255, 255, 255, 0.92);
	border-radius: 28px;
	box-shadow: 0 10px 30px rgba(213, 117, 150, 0.1);
	border: 1px solid rgba(255, 206, 222, 0.52);
	backdrop-filter: blur(10px);
}

.finance-card {
	display: flex;
	align-items: center;
	padding: 10px 0;
}

.finance-item {
	flex: 1;
	min-height: 92px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 13;
	padding: 0 12px;
}

.finance-icon-wrap {
	width: 44px;
	height: 44px;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, rgba(255, 143, 177, 0.16), rgba(244, 94, 147, 0.14));
	margin-right: 12px;
	flex-shrink: 0;
}

.finance-item .icon {
	width: 24px;
	height: 24px;
	object-fit: contain;
}

.finance-texts {
	display: flex;
	align-items: center;
}

.finance-item .text {
	font-size: clamp(18px, 4vw, 24px);
	color: #d15583;
	font-weight: 700;
	line-height: 1.2;
	text-align: center;
	word-break: break-word;
}

.finance-divider {
	width: 1px;
	height: 42px;
	background: rgba(209, 85, 131, 0.16);
}

.wallet-card {
	position: relative;
	z-index: 12;
	margin-top: 18px;
	padding: 0 18px;
	background: rgba(255, 255, 255, 0.92);
	border-radius: 28px;
	box-shadow: 0 10px 30px rgba(213, 117, 150, 0.1);
	border: 1px solid rgba(255, 206, 222, 0.52);
	backdrop-filter: blur(10px);
}

.wallet-head {
	display: flex;
	align-items: center;
	min-height: 78px;
	padding: 2px 0;
	gap: 10px;
}

.wallet-title {
	flex: 1;
	margin: 0;
	color: #cf4f7f;
	font-size: clamp(18px, 4vw, 24px);
	font-weight: 700;
	line-height: 1.2;
}

.refresh-balance-btn {
	border: none;
	background: linear-gradient(90deg, #ff8cb3 0%, #f45e93 100%);
	padding: 10px 16px;
	color: #fff;
	font-weight: 700;
	font-size: clamp(14px, 3.4vw, 18px);
	border-radius: 14px;
	line-height: 1;
	box-shadow: 0 8px 16px rgba(242, 94, 147, 0.18);
	position: relative;
	z-index: 13;
	flex-shrink: 0;
}

.wallet-body {
	padding: 10px 0 18px;
}

.wallet-item {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	min-height: 84px;
	gap: 10px;
}

.wallet-item-score {
	border-top: 1px solid rgba(207, 79, 127, 0.08);
	margin-top: 8px;
	padding-top: 14px;
}

.wallet-main {
	flex: 1;
	min-width: 0;
}

.wallet-value {
	font-size: clamp(34px, 7vw, 50px);
	color: #c84878;
	font-weight: 800;
	line-height: 1.1;
	min-width: 0;
}

.wallet-label {
	margin-left: 10px;
	font-size: clamp(15px, 3.5vw, 20px);
	color: #b87890;
	font-weight: 600;
	line-height: 1.2;
	text-align: right;
	flex-shrink: 0;
}

.menu-card {
	position: relative;
	z-index: 12;
	display: flex;
	flex-wrap: wrap;
	background: rgba(255, 255, 255, 0.92);
	border-radius: 28px;
	box-shadow: 0 10px 30px rgba(213, 117, 150, 0.1);
	border: 1px solid rgba(255, 206, 222, 0.52);
	backdrop-filter: blur(10px);
	margin-bottom: 34px;
	padding: 10px;
}

.menu-item {
	width: 50%;
	padding: 8px;
	box-sizing: border-box;
	position: relative;
	z-index: 13;
}

.menu-item-inner {
	display: flex;
	align-items: center;
	min-height: 102px;
	padding: 16px 14px;
	border-radius: 22px;
	background: linear-gradient(180deg, #fffafb 0%, #fff 100%);
	border: 1px solid rgba(241, 219, 227, 0.88);
	transition: all 0.2s ease;
	box-sizing: border-box;
	position: relative;
	z-index: 14;
}

.menu-item:active .menu-item-inner {
	transform: scale(0.98);
	background: linear-gradient(180deg, #fff4f7 0%, #fffafb 100%);
}

.menu-icon-wrap {
	width: 44px;
	height: 44px;
	border-radius: 16px;
	margin-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, rgba(255, 143, 177, 0.16), rgba(244, 94, 147, 0.12));
	flex-shrink: 0;
}

.menu-item-icon {
	width: 24px;
	height: 24px;
	object-fit: contain;
}

.menu-item-label {
	flex: 1;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	word-break: break-word;
	line-height: 1.26;
	font-size: clamp(16px, 3.6vw, 22px);
	color: #c44f7e;
	font-weight: 700;
	text-align: left;
}

::v-deep .van-hairline--bottom::after {
	border-bottom-width: 1px;
	border-color: rgba(207, 79, 127, 0.12);
}

::v-deep .van-tabbar {
	z-index: 999 !important;
}

@media screen and (max-width: 375px) {
	.mine-page {
		padding-bottom: 86px;
	}

	.page-bg {
		height: 300px;
	}

	.header-section {
		padding-bottom: 58px;
	}

	::v-deep .van-nav-bar__content {
		height: 76px;
	}

	.nav-icon-btn {
		width: 44px;
		height: 44px;
	}

	.profile-card {
		margin: 8px 14px 0;
		padding: 18px 16px;
		border-radius: 22px;
		min-height: 98px;
	}

	.avatar-wrap {
		width: 78px;
		height: 78px;
	}

	.profile-info {
		margin-left: 14px;
	}

	.name-text {
		font-size: 22px;
		max-width: 54%;
	}

	.vip-text {
		font-size: 17px;
	}

	.user-subtext {
		font-size: 14px;
	}

	.content-section {
		padding: 0 12px 18px;
		margin-top: -24px;
	}

	.finance-card {
		padding: 8px 0;
	}

	.finance-item {
		min-height: 74px;
		padding: 0 8px;
	}

	.finance-icon-wrap,
	.menu-icon-wrap {
		width: 38px;
		height: 38px;
		border-radius: 14px;
		margin-right: 10px;
	}

	.finance-item .icon,
	.menu-item-icon {
		width: 20px;
		height: 20px;
	}

	.finance-item .text {
		font-size: 15px;
	}

	.wallet-head {
		min-height: 64px;
	}

	.wallet-title {
		font-size: 17px;
	}

	.refresh-balance-btn {
		padding: 9px 12px;
		font-size: 13px;
		border-radius: 12px;
	}

	.wallet-item {
		min-height: 68px;
	}

	.wallet-value {
		font-size: 28px;
	}

	.wallet-label {
		font-size: 14px;
	}

	.menu-item {
		padding: 6px;
	}

	.menu-item-inner {
		min-height: 82px;
		padding: 12px;
		border-radius: 16px;
	}

	.menu-item-label {
		font-size: 14px;
		line-height: 1.24;
	}
}

@media screen and (max-width: 340px) {
	.profile-card {
		margin: 6px 12px 0;
		padding: 14px 12px;
	}

	.avatar-wrap {
		width: 70px;
		height: 70px;
	}

	.profile-info {
		margin-left: 10px;
	}

	.name-text {
		font-size: 19px;
		max-width: 50%;
	}

	.vip-text {
		font-size: 15px;
	}

	.finance-item .text {
		font-size: 13px;
	}

	.wallet-title {
		font-size: 15px;
	}

	.refresh-balance-btn {
		padding: 8px 10px;
		font-size: 12px;
	}

	.wallet-value {
		font-size: 24px;
	}

	.wallet-label {
		font-size: 12px;
	}

	.menu-item-label {
		font-size: 13px;
	}

	.menu-item-inner {
		padding: 10px;
	}
}
</style>

<style lang="less" scoped>
.mine-page {
	min-height: 100vh;
	padding-bottom: calc(88PX + env(safe-area-inset-bottom));
	background:
		radial-gradient(120% 42% at 50% -8%, rgba(148, 98, 36, 0.32), transparent 56%),
		radial-gradient(70% 30% at 100% 18%, rgba(112, 36, 72, 0.2), transparent 62%),
		linear-gradient(180deg, #1a140f 0%, #100d13 36%, #0c0a10 100%);
	color: #efe6d6;
	font-family: "Plus Jakarta Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
	overflow-x: hidden;
}

.page-bg,
.header-glow {
	display: none;
}

.header-section {
	padding-bottom: 8PX;
	background: linear-gradient(180deg, rgba(28, 20, 14, 0.72), rgba(28, 20, 14, 0));
}

.nav-bar,
::v-deep .van-nav-bar {
	background: transparent !important;
}

::v-deep .van-nav-bar__content {
	height: 52PX;
}

.nav-icon-btn {
	width: 34PX;
	height: 34PX;
	border: 1PX solid rgba(212, 175, 55, 0.28);
	border-radius: 8PX;
	background: rgba(255, 244, 214, 0.08);
}

::v-deep .nav-icon-btn .van-icon {
	font-size: 18PX !important;
	color: #f3d27a !important;
}

.logout-btn img {
	width: 18PX;
	height: 18PX;
	filter: brightness(0) saturate(100%) invert(84%) sepia(28%) saturate(620%) hue-rotate(6deg);
}

.profile-card {
	margin: 4PX 16PX 0;
	padding: 14PX;
	border: 1PX solid rgba(244, 216, 131, 0.2);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.09), rgba(18, 14, 22, 0.48));
	box-shadow: 0 12PX 24PX rgba(0, 0, 0, 0.28), inset 0 1PX 0 rgba(255, 236, 196, 0.1);
}

.avatar-wrap,
.user-img {
	width: 56PX;
	height: 56PX;
}

.avatar-ring {
	border-color: rgba(243, 210, 122, 0.7);
}

.name-text {
	max-width: 140PX;
	color: #fff6e4;
	font-size: 16PX;
}

.vip-icon {
	width: 16PX;
	height: 16PX;
}

.vip-text {
	color: #f3d27a;
	font-size: 12PX;
}

.user-subtext {
	color: rgba(255, 255, 255, 0.58);
	font-size: 12PX;
}

.content-section {
	margin-top: 12PX;
	padding: 0 16PX 16PX;
}

.action-card,
.wallet-card,
.menu-card {
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.075), rgba(18, 14, 22, 0.42));
	box-shadow: 0 10PX 22PX rgba(0, 0, 0, 0.24), inset 0 1PX 0 rgba(255, 236, 196, 0.08);
}

.finance-card {
	margin-bottom: 12PX;
}

.finance-icon-wrap {
	width: 28PX;
	height: 28PX;
	margin-right: 8PX;
	border: 1PX solid rgba(243, 210, 122, 0.24);
	border-radius: 8PX;
	background: rgba(243, 210, 122, 0.12);
}

.finance-item .icon {
	width: 16PX;
	height: 16PX;
	filter: brightness(0) saturate(100%) invert(86%) sepia(24%) saturate(680%) hue-rotate(6deg);
}

.finance-item .text {
	color: #f6e7c0;
	font-size: 13PX;
	font-weight: 650;
}

.finance-divider {
	background: rgba(244, 216, 131, 0.16);
}

.wallet-card {
	margin-bottom: 12PX;
}

.wallet-title,
.refresh-balance-btn {
	color: #f3d27a;
	font-size: 13PX;
}

.wallet-card .refresh-balance-btn {
	padding: 6PX 12PX;
	border: 0;
	border-radius: 8PX;
	background: linear-gradient(160deg, #fff6d4 0%, #e7c56a 48%, #c9963a 100%);
	color: #4a320c;
	font-size: 12PX;
	font-weight: 700;
	box-shadow: none;
}

.wallet-item-score {
	border-top-color: rgba(244, 216, 131, 0.14);
}

.wallet-value {
	color: #fff8e8;
	font-size: 20PX;
}

.wallet-label {
	color: rgba(255, 255, 255, 0.55);
	font-size: 12PX;
}

.menu-card {
	padding: 4PX;
	border: 0;
	background: transparent;
	box-shadow: none;
	overflow: hidden;
}

.menu-item {
	padding: 5PX;
	border-bottom: 0;
}

.menu-item-inner {
	min-height: 64PX;
	padding: 12PX 10PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 248, 230, 0.07), rgba(18, 14, 22, 0.78));
	box-shadow: inset 0 1PX 0 rgba(255, 236, 196, 0.06);
}

.menu-item:active .menu-item-inner {
	background: linear-gradient(180deg, rgba(243, 210, 122, 0.16), rgba(18, 14, 22, 0.82));
}

.menu-icon-wrap {
	width: 28PX;
	height: 28PX;
	margin-right: 8PX;
	border: 1PX solid rgba(243, 210, 122, 0.22);
	border-radius: 8PX;
	background: rgba(243, 210, 122, 0.12);
}

.menu-item-icon {
	width: 16PX;
	height: 16PX;
}

::v-deep .menu-item-icon,
::v-deep .menu-item-icon img {
	filter: brightness(0) saturate(100%) invert(86%) sepia(24%) saturate(680%) hue-rotate(6deg);
}

.mine-page .menu-item-label {
	color: #f3ead4;
	font-size: 14PX;
	font-weight: 600;
}

::v-deep .van-hairline--bottom::after {
	border-color: rgba(244, 216, 131, 0.16);
}

::v-deep .van-pull-refresh__head,
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: rgba(249, 234, 184, 0.7);
	font-size: 12PX;
}
</style>

<style lang="less" scoped>
@media (min-width: 768px) {
	.mine-page {
		min-height: 0;
		padding-bottom: 108PX;
	}

	.page-refresh,
	::v-deep .van-pull-refresh,
	::v-deep .van-pull-refresh__track {
		height: auto !important;
		min-height: 0 !important;
	}

	.header-section {
		padding-bottom: 0;
	}

	.profile-card {
		min-height: 0;
	}

	.content-section {
		min-height: 0;
		margin-top: 12PX;
		padding: 0 16PX 8PX;
	}

	.finance-card {
		padding: 0;
	}

	.finance-item {
		min-height: 52PX;
		padding: 0 12PX;
	}

	.finance-divider {
		height: 22PX;
	}

	.wallet-card {
		margin-top: 0;
		margin-bottom: 12PX;
		padding: 0 14PX;
	}

	.wallet-head {
		min-height: 46PX;
		padding: 8PX 0;
	}

	.wallet-body {
		padding: 0 0 8PX;
	}

	.wallet-item,
	.wallet-item-score {
		min-height: 0;
		margin-top: 0;
		padding: 8PX 0;
		align-items: center;
	}

	.wallet-value {
		font-size: 22PX;
		line-height: 1.2;
	}

	.menu-card {
		margin-bottom: 0;
		padding: 0;
	}

	.menu-item {
		padding: 5PX;
	}

	.menu-item-inner {
		min-height: 56PX;
		padding: 10PX;
	}
}
</style>
